import { React, useState, useEffect } from "react";

//MUI Imports
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Tooltip from '@mui/material/Tooltip'

function RiskOptions({onChosen, layerChoiceTitle, questionIndex, questionValues, riskOptions}) {

    const [optionValues, setOptionValues] = useState([]);

    function onChange(forQuestionIndex, value){

        
        let optionValuesClone = (optionValues !== undefined ? JSON.parse(JSON.stringify(optionValues)) : {})
        
        if(optionValuesClone[forQuestionIndex] === undefined || optionValuesClone[forQuestionIndex] === null)
            optionValuesClone[forQuestionIndex] = {}

        optionValuesClone[forQuestionIndex].danger = value

        setOptionValues(optionValuesClone)

        onChosen(forQuestionIndex, value , "danger")

    }

    function hasValueBeenSelected(questionIndex, optionValue){

        if(optionValues !== undefined ){
            if(optionValues[questionIndex] !== undefined && optionValues[questionIndex] !== null){
                if(optionValues[questionIndex].danger === optionValue){
                    return true
                }
            }
        }

        return false
    }

    useEffect(() => {
        setOptionValues(questionValues)
    }, [questionValues])

    return (
        <>
            <ToggleButtonGroup
                exclusive
                aria-label="Risk selection"
                sx={{
                    
                    width:"100%",
                
                }}
            >
                {
                    riskOptions.map((option, index) => {
                        return(
                            <Tooltip key={index} title={option.defaultToolTip}>
                                <ToggleButton 
                                    value={option.label} 
                                    aria-label={option.label}
                                    name={`risk${layerChoiceTitle}${questionIndex}`} 
                                    selected={hasValueBeenSelected(questionIndex, option.value)}
                                    onClick={() => onChange(questionIndex, option.value)} 
                                    sx={{
                                        fontSize:"14px",
                                        width:"calc(25% - 10px)",
                                        padding:"15px 10px"
                                    }}
                                    className={`risk_toggle_buttons`}
                                >
                                    {option.label}
                                </ToggleButton>
                            </Tooltip>
                        )
                    })
                }
            </ToggleButtonGroup>
        </>

    )
                            

}
export default RiskOptions